export default {
    data: () => ({
        translations: {
            title: {
                el: "",
                en: "Delivery Details",
                it: ""
            },
            region: {
                el: "",
                en: "Region",
                it: ""
            },
            address: {
                el: "",
                en: "Address",
                it: ""
            },
            bellName: {
                el: "",
                en: "Bell Name",
                it: ""
            },
            floor: {
                el: "",
                en: "Floor",
                it: ""
            },
            notes: {
                el: "",
                en: "Notes",
                it: ""
            }
        }
    })
};
